module.exports = __webpack_public_path__ + "img/comment.98d2c69f.svg";